export default {"src":"https://s91588.cdn.ngenix.net/affiliates-frontend/_next/static/media/offer-img.ce942730.svg","height":88,"width":125};